import React, { useState } from "react";
import Sidebar from "../../CoustamComponent/Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import QRCode from 'qrcode.react';
import copy from 'copy-to-clipboard';

const Deposit = () => {

	const [isActiveStep, setIsActiveStep] = useState("step1");
	const navigate = useNavigate();
	const location = useLocation();

	const { state } = location;

	const [formData, setFormData] = useState(
		{
			chain: state || "BEP20",
			amount: "",
			transactionHash: "",
			image: "",
			imagePath: "",
			chainAddress: state === "BEP20" || state === "ERC20" ? "0xFA3BeD8E8bfa20de9F84e9eb038d1A893ff1fEf2" : state === "TRC20" ? "TJgogFVGtjyHiJks26c9YJXR714NWFjexY" : "0xFA3BeD8E8bfa20de9F84e9eb038d1A893ff1fEf2",
		}
	);

	const handleInput = (event) => {
		const { name, value, files } = event.target;
		if (name === 'image' && files && files.length > 0) {
			const file = files[0];
			const reader = new FileReader();
			reader.onload = () => {
				setFormData(prevState => ({
					...prevState,
					image: reader.result,
					imagePath: file
				}));
			};
			reader.readAsDataURL(file);
		} else {
			if (name === 'chain') {
				let chainAddress =
					value === "ERC20" || value === "BEP20"
						? "0xFA3BeD8E8bfa20de9F84e9eb038d1A893ff1fEf2"
						: value === "TRC20"
							? "TJgogFVGtjyHiJks26c9YJXR714NWFjexY"
							: "";
				setFormData(prevState => ({
					...prevState,
					[name]: value,
					chainAddress
				}));
			} else {
				setFormData(prevState => ({
					...prevState,
					[name]: value
				}));
			}
		}
	};

	const handleNextStep = () => {
		const { chain, amount, transactionHash, image } = formData;
		if (!chain) {
			alertErrorMessage("Please select a chain");
			return;
		}
		if (!amount) {
			alertErrorMessage("Please enter an amount");
			return;
		}
		if (parseFloat(amount) < 25) {
			alertErrorMessage("Minimum Deposit: USDT 25");
			return;
		}
		if (!transactionHash) {
			alertErrorMessage("Please enter a transaction hash");
			return;
		}
		if (!image) {
			alertErrorMessage("Please upload an image");
			return;
		}
		setIsActiveStep("step2");
	};

	const handleDeposit = async () => {
		var formValue = new FormData();
		formValue.append("chain", formData.chain);
		formValue.append("amount", formData.amount);
		formValue.append("transaction_hash", formData.transactionHash);
		formValue.append("address", formData.chainAddress);
		formValue.append("transaction_image", formData.imagePath);
		LoaderHelper.loaderStatus(true);
		try {
			const result = await AuthService.depositAmount(formValue);
			LoaderHelper.loaderStatus(false);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				navigate('/deposit_history')
			} else {
				alertErrorMessage(result);
			}
		} catch (error) {
			LoaderHelper.loaderStatus(false);
			alertErrorMessage(error);
		}
	};

	return (
		<div class="wrapper dashboard_page ">
			<div class=" page-body d-flex align-items-stretch">
				<div class="page-content">
					<Sidebar />
					<div className="page_wrapper" >
						<div className="container container-custom" >
							<div className="row g-3" >
								<div className="col-lg-12" >
									<div className="card bal_card_main" >
										{
											isActiveStep === "step1" &&
											<div class="card-body">
												<div className="d-flex align-items-start">
													<Link to="/dashboard" className="page-header-icon me-2 mt-1">
														<i class="fa-solid fa-arrow-left fs-3"></i>
													</Link>
													<h4 className="mb-4" >
														New deposit to your Wallet
													</h4>
												</div>
												<div class="form-group mb-4">
													<label> Select Chain </label>
													<select className="form-select" name="chain" value={formData?.chain} onChange={handleInput}>
														<option value="BEP20"> BEP20 </option>
														<option value="ERC20"> ERC20 </option>
														<option value="TRC20"> TRC20 </option>
													</select>
												</div>

												<div className="qr_body d-flex">
													<QRCode value={formData?.chainAddress} className="img-fluid" />
													<div className="qr_add">
														<div>
															<span className="text-muted">Address</span>
															<p> {formData?.chainAddress} </p>
														</div>
														<span className="px-2 cursor-pointer btn-copy" onClick={() => { copy(formData?.chainAddress); alertSuccessMessage("Deposit Address copied..!!") }}> <i className="ri-file-copy-fill "></i> </span>
													</div>
												</div>

												<div class="form-group mt-2">
													<label> Enter Amount </label>
													<input type="text" class="form-control" placeholder="Enter Amount" name="amount" value={formData?.amount} onChange={(e) => (/^\d*$/.test(e.target.value) && handleInput(e))} />
												</div>
												<div class="balance-libra card-success mb-4">
													<div class="token-img-bg_right" id="lc-data"> Minimum Deposit :- <b>USDT 25</b> </div>
												</div>
												<div class="form-group mb-4">
													<label> Enter Transaction Hash   </label>
													<input type="text" class="form-control" placeholder="Enter Transaction Hash" name="transactionHash" value={formData?.transactionHash} onChange={handleInput} />
												</div>
												<div class="form-group mb-4">
													<label>  Upload Screenshot Of Payment </label>
													<input type="file" class="form-control" placeholder="Enter Deposit Slip" name="image" onChange={handleInput} />
												</div>
												<button type="button" class="btn btn-primary btn-md w-100 btn-block" onClick={handleNextStep}> CONTINUE </button>
											</div>
										}

										{
											isActiveStep === "step2" &&
											<div class="card-body">
												<h4 className="mb-4" >
													<button className="btn back_arrow" type="button" onClick={() => setIsActiveStep("step1")}> <i class="ri-arrow-left-line"></i> </button> Final Check
												</h4>
												<div class="tt_data mb-4">
													<div class="tt_item no-border">
														<span class="text-muted"> Chain Name </span>
														<span class="tt_normal">{formData?.chain}</span>
													</div>
													<div class="tt_item no-border">
														<span class="text-muted"> Amount </span>
														<span class="tt_normal">{formData?.amount}</span>
													</div>
													<div class="tt_item no-border">
														<span class="text-muted"> TransactionHash </span>
														<span class="tt_normal">{formData?.transactionHash}</span>
													</div>
												</div>
												<button type="button" class="btn btn-primary btn-md w-100 btn-block" onClick={handleDeposit}> MAKE DEPOSIT </button>
											</div>
										}

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Deposit
